// @ts-strict
import {type CategoryLevel1} from './types';

export type CascadeOption = {
  value: string; // exact Salesforce wire value
  labelKey: string;
};

export const CATEGORY_LEVEL_1: {
  value: CategoryLevel1;
  labelKey: string;
  categoryLevel2LabelKey: string;
}[] = [
  {
    value: 'Order',
    labelKey: 'components.SupportMessage.categoryLevel1.order',
    categoryLevel2LabelKey: 'components.SupportMessage.fields.categoryLevel2.order',
  },
  {
    value: 'Account',
    labelKey: 'components.SupportMessage.categoryLevel1.account',
    categoryLevel2LabelKey: 'components.SupportMessage.fields.categoryLevel2.account',
  },
  {
    value: 'General/Other',
    labelKey: 'components.SupportMessage.categoryLevel1.general',
    categoryLevel2LabelKey: 'components.SupportMessage.fields.categoryLevel2.general',
  },
];

// Values must exist in the ez-rails CategoryCascade or submission fails its pair check.
// DRAFT COPY marks wording that still needs product sign-off.
export const CUSTOMER_CASCADE: Record<CategoryLevel1, CascadeOption[]> = {
  Order: [
    {value: 'Cancellation', labelKey: 'components.SupportMessage.categoryLevel2.cancellation'},
    {value: 'Modification', labelKey: 'components.SupportMessage.categoryLevel2.modification'},
    // DRAFT COPY
    {value: 'Delete Draft', labelKey: 'components.SupportMessage.categoryLevel2.deleteDraft'},
    {value: 'New Order', labelKey: 'components.SupportMessage.categoryLevel2.newOrder'},
    {value: 'Issue', labelKey: 'components.SupportMessage.categoryLevel2.issue'},
    {value: 'Clarification', labelKey: 'components.SupportMessage.categoryLevel2.clarification'},
    // DRAFT COPY
    {
      value: 'Technical Issue',
      labelKey: 'components.SupportMessage.categoryLevel2.technicalIssueOrder',
    },
    {value: 'Status Check', labelKey: 'components.SupportMessage.categoryLevel2.statusCheck'},
  ],
  Account: [
    {value: 'Billing & Payment', labelKey: 'components.SupportMessage.categoryLevel2.billing'},
    // DRAFT COPY
    {value: 'Concierge', labelKey: 'components.SupportMessage.categoryLevel2.concierge'},
    {value: 'Fraud', labelKey: 'components.SupportMessage.categoryLevel2.fraud'},
    // DRAFT COPY
    {
      value: 'Legal and Compliance',
      labelKey: 'components.SupportMessage.categoryLevel2.legalCompliance',
    },
    {value: 'Meal Program', labelKey: 'components.SupportMessage.categoryLevel2.mealProgram'},
    {value: 'Rewards', labelKey: 'components.SupportMessage.categoryLevel2.rewards'},
    {value: 'Form Request', labelKey: 'components.SupportMessage.categoryLevel2.formRequest'},
    {value: 'Onboarding', labelKey: 'components.SupportMessage.categoryLevel2.onboarding'},
    // DRAFT COPY
    {value: 'SSO', labelKey: 'components.SupportMessage.categoryLevel2.sso'},
    // DRAFT COPY
    {
      value: 'Assign Account Support (e.g. AE)',
      labelKey: 'components.SupportMessage.categoryLevel2.accountSupport',
    },
    {value: 'Tax', labelKey: 'components.SupportMessage.categoryLevel2.tax'},
    {value: 'Account Update', labelKey: 'components.SupportMessage.categoryLevel2.accountUpdate'},
    {value: 'Other', labelKey: 'components.SupportMessage.categoryLevel2.other'},
  ],
  'General/Other': [
    {value: 'Feedback', labelKey: 'components.SupportMessage.categoryLevel2.feedback'},
    {
      value: 'Technical Issue',
      labelKey: 'components.SupportMessage.categoryLevel2.technicalIssue',
    },
  ],
};
